import React, { useState,useEffect,useContext } from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso,Loading,FacturationSelectDossier,SearchDataTable,FilterSearchBilling,EcotaxeDataTable,BarNumSearchBilling} from '@gull'
import axios from 'axios';
import swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { IsAuthContext } from 'app/App';
import { Tabs, Tab } from "react-bootstrap";

const useLoad = (authParam,props) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [allDocuments,setAllDocuments] = useState([]) 
    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [sizeDatas,setSizeDatas]=useState(0)
    const [company,setCompany] = useState(false) 
    const [loadingTable,setLoadingTable] = useState(true)

    function formatDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
    }

    let today = new Date();

    // Obtenir la date d'il y a 7 jours
    let sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    let todayFormated = formatDate(today)
    let sevenDaysAgoFormated = props.createdDate ? props.createdDate.split(' ')[0] : formatDate(sevenDaysAgo) //Si on est dans le module de recherche depuis le détail d'un document, on passe sa date de création au filtre "début de période"
    let defaultType = props.documentType ? props.documentType : '' //Si on est dans le module de recherche depuis le détail d'un document, on passe le type du doc au filtre pour n'avoir que les documents du memes type
    let defaultEntreprise = props.companyId ? props.companyId : '' //Si on est dans le module de recherche depuis le détail d'un document, on passe le type du doc au filtre pour n'avoir que les documents du memes type
    let defaultCustomer = props.infoClient ? props.infoClient : {}

    let initExportParam = {
        cancelled:'excludeCancelled'//on ne met pas les documents exclus au premier appel
    }

    if(props.documentType){
        initExportParam['type'] = props.documentType
        initExportParam['other_company'] = props.companyId
    }
    if(props.infoClient) initExportParam['client'] = props.infoClient.id

    const [exportParam,setExportParam]=useState(initExportParam) 
    const [reload,setReload] = useState(Date.now())
    const [validButton,setValidButton]=useState(false) 

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/company/"+authParam.company.id
            ).then((response) => {
                setCompany(response.data)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
                setCompany({})
            })
        })()
    }, [])

    useEffect(function () {
        (async function() {
            setLoadingTable(true)
            setValidButton(true)
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/facture/invoice/get_all/"+perPage+"/"+currentPage, exportParam
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{   
                    setAllDocuments(response.data.datas)
                    setSizeDatas(response.data.count)
                    setLoading(false)
                }
                setLoadingTable(false)
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
                setLoading(false)
                setLoadingTable(false)
            })
            setValidButton(false)
        })()
    }, [reload])

    return [loading,allDocuments,sizeDatas,setPerPage,setSizeDatas,setAllDocuments,sevenDaysAgoFormated,todayFormated,perPage,company,exportParam,setExportParam,setCurrentPage,currentPage,reload,setReload,validButton,defaultType,defaultEntreprise,defaultCustomer,loadingTable]
}

const SearchBilling = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);
    const [loading,allDocuments,sizeDatas,setPerPage,setSizeDatas,setAllDocuments,sevenDaysAgoFormated,todayFormated,perPage,company,exportParam,setExportParam,setCurrentPage,currentPage,reload,setReload,validButton,defaultType,defaultEntreprise,defaultCustomer,loadingTable]=useLoad(authParam,props)

    const history = useHistory();

    // Tableau affiché
    const [tabsKey,setTabsKey] = useState("billing")

    const callbackFolderLink = (folder) => {
        history.push("/invoice/folder-detail/"+folder.id)
    };

    if(loading){
        return(<Loading></Loading>)
    }

    return (
        <div>
            <div className="row mb-2">
                <div className="col-6 d-flex">
                    <FilterSearchBilling 
                        validButton={validButton}
                        sevenDaysAgoFormated={sevenDaysAgoFormated}
                        todayFormated={todayFormated}
                        company={company}
                        setExportParam={setExportParam}
                        setReload={setReload}
                        defaultType={defaultType}
                        defaultEntreprise={defaultEntreprise}
                        defaultCustomer={defaultCustomer}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
                <div className="col-3 d-flex">
                    <CardPerso header={t('tableSearch')+' '+t('folder').toLowerCase()}>
                        <FacturationSelectDossier callbackFolderLink={callbackFolderLink} size='100%'/>
                    </CardPerso>
                </div>
                <div className="col-3 d-flex">
                    <BarNumSearchBilling  company={company} />
                </div>
            </div>
            <Tabs activeKey={tabsKey} id="uncontrolled-tab-example" className="position-relative mt-3" onSelect={(k)=>setTabsKey(k) }>
                <Tab eventKey="billing" title={t('billing')}>
                    <SearchDataTable 
                        allDocuments={allDocuments}
                        sizeDatas={sizeDatas}
                        setPerPage={setPerPage}
                        perPage={perPage}
                        setSizeDatas={setSizeDatas}
                        setAllDocuments={setAllDocuments}
                        setCurrentPage={setCurrentPage}
                        exportParam={exportParam}
                        currentPage={currentPage}
                        setReload={setReload}
                        reload={reload}
                        loadingTable={loadingTable}
                        clientSearch={false}
                    />
                </Tab>
                <Tab eventKey="ecotaxe" title={t('ecotaxe')}>
                    <EcotaxeDataTable 
                        allDocuments={allDocuments}
                        sizeDatas={sizeDatas}
                        setPerPage={setPerPage}
                        perPage={perPage}
                        setSizeDatas={setSizeDatas}
                        setAllDocuments={setAllDocuments}
                        setCurrentPage={setCurrentPage}
                        exportParam={exportParam}
                        reload={reload}
                    />
                </Tab>
            </Tabs>
            
        </div>
    )
};

export default SearchBilling;